import Urls from '../urls.js';
import { fetcher } from '../../../../scripts/utils/fetch.js';
import BaseView from '../../../../scripts/utils/base-view.js';

export default class AddToWishListView extends BaseView {
	constructor({
		el,
		product_id,
		logged_user,
		in_wishlist
	}) {
		super(el);
		this.template_url = Urls.Templates.app;
		this.parent_element = document.querySelector(el);
		this.product_id = product_id;
		this.logged_user = logged_user;
		this.in_wishlist = in_wishlist;
		this.render();
	}

	get_context () {
		return {
			logged_user: this.logged_user,
			in_wishlist: this.in_wishlist
		};
	}

	after_render () {
		this.initSelectors();
	}

	initSelectors () {
		this.removeListeners();
		this.wishlist_element = this.el.querySelector('.wishlist');
		this.addListeners();
	}

	addListeners () {
		if (this.wishlist_element) {
			this.wishlist_element.addEventListener('click', this.addToWishlist.bind(this));
		}
	}

	removeListeners () {
		if (this.wishlist_element) {
			this.wishlist_element.removeEventListener('click', this.addToWishlist.bind(this));
		}
	}

	addToWishlist (event) {
		const btn_add_to_wishlist = event.currentTarget;

		if (this.logged_user && !this.in_wishlist) {
			event.preventDefault();
			btn_add_to_wishlist.classList.add('progress');

			fetcher(Urls.Api.product, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ ProductId: this.product_id })
			})
			.then(() => {
				this.in_wishlist = true;
				this.render();
			});
		}
	}
}